module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_problem_img01-1753b46a7043e940fd8fe48c3e7c1393.svg";